import { useEffect, useState } from 'react';
import { ColumnPreferences } from '../types';

/**
 * Hook para manejar la persistencia de preferencias de columnas
 * Carga automáticamente las preferencias guardadas al inicializar
 */
export const useColumnPersistence = (
  storageKey: string | undefined,
  availableColumns: Array<{ id: string }>,
  onLoadPreferences: (columns: string[]) => void
) => {
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    if (!storageKey || isLoaded || availableColumns.length === 0) return;

    try {
      const stored = localStorage.getItem(`columnSelector_${storageKey}`);
      if (!stored) {
        setIsLoaded(true);
        return;
      }

      const preferences: ColumnPreferences = JSON.parse(stored);

      // Verificar que las columnas guardadas aún existen
      const validColumns = preferences.selectedColumns.filter((columnId) =>
        availableColumns.some((col) => col.id === columnId)
      );

      if (validColumns.length > 0) {
        onLoadPreferences(validColumns);
      }
    } catch (error) {
      console.warn('Error loading column preferences:', error);
    } finally {
      setIsLoaded(true);
    }
  }, [storageKey, availableColumns.length, onLoadPreferences, isLoaded]);

  return { isLoaded };
};
